module.exports = __webpack_public_path__ + "assets/img/kuhuan.1fb37602.jpg";